import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 27 2018
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CONSTANTS } from '../../../constants';
import { action, observable, runInAction } from 'mobx';
import { SettingsLayer } from '../../transportLayers/general-settings/SettingsLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Settings for release, so called matrix table, such as optimization goals settings, strategy settings,
 * constraints or rounding rules settings.
 */

export var SettingsStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SettingsStore, _BaseStore);

  function SettingsStore() {
    var _this;

    _classCallCheck(this, SettingsStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsStore).apply(this, arguments));
    _this.name = StoreName.SettingsStore;
    _this.settingsLayer = new SettingsLayer();
    _this.list = new Map();
    _this.listResolved = new Map();

    _this.getAll = function (catId, params) {
      return _this.settingsLayer.getGroupedByZone(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_CATEGORY, catId, params).then(function (settings) {
        runInAction(function () {
          _this.list = settings;
        });
        return settings;
      });
    };

    _this.getResolvedSettings = function (catId, params) {
      return _this.settingsLayer.getGroupedByZone(CONSTANTS.API.ENDPOINTS.GENERAL_SETTINGS_RESOLVE_CATEGORY, catId, params).then(function (settings) {
        runInAction(function () {
          _this.listResolved = settings;
        });
        return settings;
      });
    };

    _this.copyBetweenZones = function (data) {
      return _this.settingsLayer.copyZones(data).then(function (settings) {
        runInAction(function () {
          _this.list = new Map([].concat(_toConsumableArray(_this.list), _toConsumableArray(settings)));
        });
        return settings;
      });
    };

    _this.copyFromCategory = function (data) {
      return _this.settingsLayer.copyCategory(data).then(function (settings) {
        runInAction(function () {
          _this.list = new Map([].concat(_toConsumableArray(_this.list), _toConsumableArray(settings)));
        });
        return settings;
      });
    };

    return _this;
  }

  return SettingsStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], SettingsStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Object)], SettingsStore.prototype, "listResolved", void 0);

__decorate([action, __metadata("design:type", Object)], SettingsStore.prototype, "getAll", void 0);

__decorate([action, __metadata("design:type", Object)], SettingsStore.prototype, "getResolvedSettings", void 0);